import React, { useEffect, useState } from 'react';
import { Gamepad2 } from 'lucide-react';
import { resolveApiAssetUrl } from '../lib/api';
import { isVideoAsset } from '../lib/mediaAsset';

// Oyun görseli üç kaynaktan gelebilir: sağlayıcının mutlak adresi, yöneticinin
// panelden yüklediği özel görsel (`/api/uploads/images/...`) ve aynı yoldan
// yüklenen hareketli kart (MP4/WEBM). İkincisi göreli olduğu için backend ayrı
// bir origin'deyse (REACT_APP_BACKEND_URL dolu) çözülmeden yüklenmez ve kart
// sessizce yedek ikona düşerdi — "panelden görsel ekledim ama sitede
// görünmüyor".
//
// Video ile görseli ayıran tek yer burasıdır: `<img src="...mp4">` hiçbir
// tarayıcıda çizilmez, kart boş kalır. Bu yüzden oyun görselini doğrudan
// `<img>` ile yazmayın, bu bileşenden geçirin.
const GameArtwork = ({ src, alt, loading = 'lazy', className }) => {
  const [failed, setFailed] = useState(false);
  const resolved = resolveApiAssetUrl(src);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!resolved || failed) {
    return (
      <div className="game-artwork-fallback" role="img" aria-label={alt}>
        <Gamepad2 size={28} aria-hidden="true" />
        <span>{alt}</span>
      </div>
    );
  }

  if (isVideoAsset(resolved)) {
    return (
      // Kart bir dekordur, oynatıcı değil: kontrol çubuğu çizilmez ve ses
      // yoktur. `muted` + `playsInline` şarttır — ikisi olmadan mobil
      // tarayıcılar otomatik oynatmayı reddeder ve kart donuk bir ilk karede
      // kalır. `preload="metadata"` katalogda onlarca kartın tüm videoyu
      // birden indirmesini önler.
      <video
        src={resolved}
        className={className}
        aria-label={alt}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
};

export default GameArtwork;
